import Settings from "./Settings";
import { AuthToken } from "./AuthToken";

import ProcessingResult from "../framework/ProcessingResult";

import GetFieldsResult from "../classes/api/result/datastructuremodule/GetFieldsResult";
import FieldReferenceIdAndKeyDto from "../classes/dtos/FieldReferenceIdAndKeyDto";
import FieldTypeReferenceDto from "../classes/dtos/FieldTypeReferenceDto";

const FieldApi = {

    GetRawFieldsAsync: async function (dataSourceId: number, tableReferenceId: number, forceUpdate: boolean): Promise<ProcessingResult<GetFieldsResult>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Field/GetRawFields?DataSourceId=" + dataSourceId.toString() + "&TableReferenceId=" + tableReferenceId.toString() + "&ForceUpdate=" + forceUpdate.toString(), {
            method: "Get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new GetFieldsResult(data.accepted, data.status, data.lastUpdateDate, data.fields.map((e: any) => new FieldReferenceIdAndKeyDto(e.id, e.sourceKey, e.datasetKey, e.name, new FieldTypeReferenceDto(e.type.type, e.type.isMultiple, e.type.typeLabel, e.type.isNullable, e.type.maxLength, e.type.isReadOnly, e.type.isCalculated, e.type.isBusinessRequired, e.type.isPrimaryKey, e.type.originTypeLabel, e.type.linkTableId)))));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    GetComputedFieldsAsync: async function (tableReferenceId?: number | null, pathId?: number | null): Promise<ProcessingResult<GetFieldsResult>> {
        let authSession = await AuthToken.get();

        let queryString = "";
        let separator = "?";

        if (tableReferenceId !== undefined && tableReferenceId !== null) {
            queryString += separator + "TableReferenceId=" + tableReferenceId.toString();
            separator = "&";
        }

        if (pathId !== undefined && pathId !== null) {
            queryString += separator + "PathId=" + pathId.toString();
        }

        const response = await fetch(Settings.api_url + "/Field/GetComputedFields" + queryString, {
            method: "Get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new GetFieldsResult(data.accepted, data.status, data.lastUpdateDate, data.fields.map((e: any) => new FieldReferenceIdAndKeyDto(e.id, e.sourceKey, e.datasetKey, e.name, new FieldTypeReferenceDto(e.type.type, e.type.isMultiple, e.type.typeLabel, e.type.isNullable, e.type.maxLength, e.type.isReadOnly, e.type.isCalculated, e.type.isBusinessRequired, e.type.isPrimaryKey, e.type.originTypeLabel, e.type.linkTableId)))));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    }
};

export default FieldApi;